
import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { QATable } from "./QATable";
import { QAForm } from "./QAForm";
import { useQAManagement } from "./useQAManagement";
import { FileItem } from "../files/types";

export default function QAManagement() {
  const {
    qaItems,
    editingItem,
    isLoading,
    setEditingItem,
    handleSaveQA,
    handleDeleteQA,
    handleUpdateQA,
    cancelEdit,
    startEditingQA,
    toggleActiveStatus,
    categories
  } = useQAManagement();
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <Card className="md:col-span-2">
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Λίστα Ερωτήσεων & Απαντήσεων</CardTitle>
        </CardHeader>
        <CardContent>
          <QATable
            qaItems={qaItems}
            editingItem={editingItem}
            isLoading={isLoading}
            onStartEdit={startEditingQA}
            onCancelEdit={cancelEdit}
            onSaveEdit={handleUpdateQA}
            onDeleteQA={handleDeleteQA}
            onToggleActive={toggleActiveStatus}
          />
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>{editingItem ? 'Επεξεργασία Q&A' : 'Προσθήκη Νέου Q&A'}</CardTitle>
        </CardHeader>
        <CardContent>
          <QAForm 
            editingItem={editingItem}
            onSaveQA={handleSaveQA}
            onCancelEdit={cancelEdit}
            categories={categories}
          />
        </CardContent>
      </Card>
    </div>
  );
}
